<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.1789 4.1789C4.47179 3.88601 4.94667 3.88601 5.23956 4.1789L10.5 9.43931V5.23956C10.5 4.82535 10.8358 4.48956 11.25 4.48956C11.6642 4.48956 12 4.82535 12 5.23956V11.25C12 11.6642 11.6642 12 11.25 12H5.23956C4.82535 12 4.48956 11.6642 4.48956 11.25C4.48956 10.8358 4.82535 10.5 5.23956 10.5H9.43931L4.1789 5.23956C3.88601 4.94667 3.88601 4.47179 4.1789 4.1789Z"
    fill="currentColor"
  />
</svg>
